module.exports = __webpack_public_path__ + "static/media/Fourth-Arrow.e1f6b0c6.png";